import * as Yup from "yup";

const AlbumSchema = Yup.object().shape({
  title: Yup.string().required("Please enter a title"),
  image: Yup.string(),
  
});

export default AlbumSchema;
